import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Manager, Popper, Reference } from 'react-popper'
import { ChromePicker } from 'react-color'
import { withStateHandlers } from 'recompose'
import { z } from '../../style'
import onClickOutside from 'react-onclickoutside'

const ColorPicker = onClickOutside(ChromePicker)

const rgba = color =>
  `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`

const ColorButton = ({
  color,
  onChange,
  showPicker,
  toggle,
  children,
  ...props
}) => (
  <Manager>
    <Reference>{props => children({ ...props, toggle, showPicker })}</Reference>
    {showPicker &&
      ReactDOM.createPortal(
        <Popper>
          {({ ref, style }) => (
            <div
              ref={ref}
              style={{ ...style, zIndex: z.colorPicker }}
              className="color-picker"
            >
              <ColorPicker
                handleClickOutside={() => toggle()}
                color={color}
                onChangeComplete={color => onChange(rgba(color))}
                className="ignore-react-onclickoutside"
              />
            </div>
          )}
        </Popper>,
        document.body
      )}
  </Manager>
)

ColorButton.propTypes = {
  children: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default withStateHandlers(
  { showPicker: false },
  {
    toggle: ({ showPicker }) => () => ({ showPicker: !showPicker })
  }
)(ColorButton)
